var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantParent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.2712,
    height: 76.2712,
    rx: 16,
    fill: "url(#paint0_radial_186_3485)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 34.958,
    width: 9.5339,
    height: 9.5339,
    rx: 1.52542,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.957,
    y: 38.1357,
    width: 9.5339,
    height: 6.35593,
    rx: 1.52542,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6699,
    y: 34.958,
    width: 9.5339,
    height: 9.5339,
    rx: 1.52542,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2461,
    y: 47.6699,
    width: 9.5339,
    height: 9.5339,
    rx: 1.52542,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6699,
    y: 22.2461,
    width: 9.5339,
    height: 9.5339,
    rx: 1.52542,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.957,
    y: 22.2461,
    width: 9.5339,
    height: 6.35593,
    rx: 1.52542,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8355 15.8896L25.9814 21.6887L31.7805 23.8346L25.9814 25.9804L23.8355 31.7795L21.6897 25.9804L15.8906 23.8346L21.6897 21.6887L23.8355 15.8896Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_186_3485",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2712) rotate(135) scale(107.864 83.0071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78F814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159A6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantParent);
export default __webpack_public_path__ + "static/media/assistant-parent.f0e3674b.svg";
export { ForwardRef as ReactComponent };